import { render, staticRenderFns } from "./zb_level.vue?vue&type=template&id=5664e532&scoped=true"
import script from "./zb_level.vue?vue&type=script&lang=ts"
export * from "./zb_level.vue?vue&type=script&lang=ts"
import style0 from "./zb_level.vue?vue&type=style&index=0&id=5664e532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664e532",
  null
  
)

export default component.exports